module.exports = __webpack_public_path__ + "static/media/1.d50a7d08.png";